// Converts a string in snake_case or SCREAMING_SNAKE_CASE to Title Case
export function snakeCaseToTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
